<template>
    <div class="card light-back max-content-width w-100">
        <div class="card-body">
            <div class="small-box">
                <div class="step-title">1. {{$t("Kuulutuse tuup")}}</div>
                <div class="help-block">{{$t("Vali millist tuupi kuulutust soovid avaldada")}}</div>

                <div class="custom-control custom-checkbox medium-back colored-border vertical-margin">
                    <input v-model="adType" value="advertisement" type="radio" name="adType"
                           class="custom-control-input"
                           id="kuulutus">
                    <label v-bind:class="{'font-weight-bold':adType=='advertisement'}" class="custom-control-label"
                           for="kuulutus">{{$t('advertisement')}}</label>
                </div>

                <div class="custom-control custom-checkbox medium-back colored-border vertical-margin">
                    <input v-model="adType" value="greeting" type="radio" name="adType" class="custom-control-input"
                           id="onnitlus">
                    <label v-bind:class="{'font-weight-bold':adType=='greeting'}" class="custom-control-label"
                           for="onnitlus">{{$t('greeting')}}</label>
                </div>

                <div class="custom-control custom-checkbox medium-back colored-border vertical-margin">
                    <input v-model="adType" value="condolence" type="radio" name="adType"
                           class="custom-control-input" id="kaastundeavaldus">
                    <label v-bind:class="{'font-weight-bold':adType=='condolence'}" class="custom-control-label"
                           for="kaastundeavaldus">{{$t('condolence')}}</label>
                </div>

                <a @click="changeStep()" v-bind:class="{disabled: adType==null || store.isLoading}" class="btn btn-primary btn-block">
                    <MoveForwardButton />
                </a>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useMainStore } from '../includes/store';
import MoveForwardButton from './MoveForwardButton.vue';

const store = useMainStore();

const adType = ref(null);

onMounted(() => {
    loadState();

    if (adType.value != null) {
        saveState();
    }
})

const changeStep = () => {
    saveState();
    store.changeStep('newspapers');
}

const loadState = () => {
    if (store.stepInfo.adType) {
        adType.value = store.stepInfo.adType;
    }
}

const saveState = async () => {
    store.setIsLoading(true);
    store.setAdType(adType.value);
    try {
        await axios.post('/state/adType', {
            state: adType.value
        })
        console.log("Type state changed");
    } catch (e) {
        store.sessExpired();
    } finally {
        store.setIsLoading(false);
    }
}

watch(() => store.stateLoaded, (loaded) => {
    if (loaded) {
        loadState();
    }
}, { immediate: true });

watch(() => store.stepInfo.adType, (adType) => {
    if (adType) {
        loadState();
    }
});

watch(() => adType.value, () => {
    saveState();
});
</script>
